import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full" data-id="element-149">
      {/* Article-style title above the image */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="max-w-editorial mx-auto px-4 pt-12 pb-8 md:pt-16 md:pb-10 text-center" data-id="element-150">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold leading-tight text-charcoal" data-id="element-151">
          5 Dinge, die die meisten Haarausfall-Artikel falsch machen
        </h1>
        <p className="mt-4 text-lg md:text-xl font-body italic text-charcoal/70" data-id="element-152">
          (und warum dein Scheitel deshalb immer breiter wird)
        </p>
      </motion.div>

      {/* Standalone full-width image */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 0.3
    }} className="w-full max-w-5xl mx-auto px-4 mb-12" data-id="element-153">
        <img src="https://cdn.magicpatterns.com/uploads/vbWEttEeSN2XdmVTuByVEN/01_VorherNacher-1024x683-1.jpg" alt="Vorher-Nachher-Vergleich: sichtbare Verbesserung der Haardichte" className="w-full h-auto rounded-sm shadow-lg" data-id="element-154" />
      </motion.div>
    </section>;
}